import { configureStore } from "@reduxjs/toolkit";
import { useDispatch } from "react-redux";
import rootReducer from "../reducer/index";
// import logger from 'redux-logger';

const isDev = process.env.NODE_ENV === "development";

const firstMiddleware = () => (next: any) => (action: any) => {
  // console.log('로깅', action);
  next(action);
};

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(firstMiddleware),
});
export default store;

export type AppDispatch = typeof store.dispatch;
export const useAppDispatch = () => useDispatch<AppDispatch>();

// import {configureStore} from '@reduxjs/toolkit';
// import {useDispatch} from 'react-redux';
// import logger from 'redux-logger';

// const reducer = require('./reducers');

// const firstMiddleware = () => (next) => (action) => {
//   console.log('로깅', action);
//   next(action);
// };

// const store = configureStore({
//   reducer,
//   middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(firstMiddleware),
// });

// export type AppDispatch = typeof store.dispatch;
// export const useAppDispatch = () => useDispatch<AppDispatch>();

// module.exports = store;

// import {configureStore} from '@reduxjs/toolkit';
// import {useDispatch} from 'react-redux';
// import rootReducer from '../reducer/index';
// import logger from 'redux-logger';

// const isDev = process.env.NODE_ENV === 'development';

// const store = configureStore({
//   reducer: rootReducer,
//   middleware: getDefaultMiddleware => {
//     if (isDev) {
//       // const createDebugger = require('redux-flipper').default;
//       // return getDefaultMiddleware().concat(createDebugger());
//       middleware.push(logger);
//     }
//     return getDefaultMiddleware();
//   },
// });
// export default store;

// export type AppDispatch = typeof store.dispatch;
// export const useAppDispatch = () => useDispatch<AppDispatch>();
